// extracted by mini-css-extract-plugin
export var container = "_sp-0";
export var dotAnimation = "_sp-2";
export var dotsLoading = "_sp-1";